/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Guide_Updated_LabelInputs */



/**
* | output |
* | --- |
* | "Updated:" |
*
* @param {Knp_Guide_Updated_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_guide_updated_label = /** @type {((inputs?: Knp_Guide_Updated_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Guide_Updated_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mis à jour :")
	if (locale === "de") return /** @type {LocalizedString} */ ("Aktualisiert:")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiornato:")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обновлено:")
	if (locale === "es") return /** @type {LocalizedString} */ ("Actualizado:")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("更新：")
	if (locale === "ja") return /** @type {LocalizedString} */ ("更新日:")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अपडेट किया गया:")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Atualizado:")
	return /** @type {LocalizedString} */ ("Updated:")
});